import BloomBreadcrumbChevronSvg from '@assets/images/svg/bloom-breadcrumb-chevron.svg';
import { getColors } from '@/core/constants/uiColors';
import React from 'react';
import { StyleSheet, View } from 'react-native';

const bloomColors = getColors();

export interface BloomBreadcrumbChevronIconProps {
  /** Height in px — width scales from Figma 7×11. */
  readonly size?: number;
  readonly color?: string;
}

/**
 * Figma breadcrumb separator chevron (7×11).
 * Distinct from shared `ChevronRightIcon` / `chevron-right.svg`.
 */
export function BloomBreadcrumbChevronIcon({
  size = 11,
  color = bloomColors.bloomUniversalMuted,
}: Readonly<BloomBreadcrumbChevronIconProps>) {
  const width = Math.round((7 / 11) * size);
  return (
    <View style={[styles.wrap, { width, height: size }]}>
      <BloomBreadcrumbChevronSvg width={width} height={size} color={color} />
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default BloomBreadcrumbChevronIcon;
